module.exports = __webpack_public_path__ + "img/iconfont.466cd866.svg";